import { router } from '@/router';

export default {

    redirect(path = '', blank= false){
        if (blank) {
            window.open(`/#${path}`, "_blank")
        } else {
            router.push({ path: path });
        }
    },

}